<template>
    <div class="main">
        <el-dialog
            :close-on-click-modal="false"
            :title="openData.title"
            :visible.sync="openData.state"
            width="700px"
            @close="dialogClose"
        >
            <div class="content">
                <el-form
                    label-width="100px"
                    :model="formData"
                    ref="forms"
                    :disabled="openData.title == '查看'"
                    :rules="formDataRules"
                >
                    <el-form-item label="组织类型:" prop="orgType">
                        <el-radio-group v-model="formData.orgType">
                            <el-radio label="0">组织工作</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="计划类型:" prop="planType">
                        <el-checkbox-group v-model="formData.planType">
                            <el-checkbox label="0">社区活动</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="年份:" prop="years">
                        <el-select
                            style="width: 100%"
                            v-model="formData.years"
                            clearable
                            placeholder="请选择年份"
                        >
                            <el-option
                                v-for="item in yearList"
                                :key="item"
                                :label="item"
                                :value="item"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="周期:" prop="cycle">
                        <el-select
                            style="width: 100%"
                            v-model="formData.cycle"
                            clearable
                            placeholder="请选择周期"
                        >
                            <el-option
                                v-for="item in cycleList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option
                        ></el-select>
                    </el-form-item>
                    <el-form-item label="频次:" prop="frequency">
                        <el-input
                            v-model.number="formData.frequency"
                            placeholder="请输入频次"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="组织:" prop="communityId">
                        <el-select
                            style="width: 100%"
                            disabled
                            v-model="formData.communityId"
                            clearable
                            placeholder="请选择组织"
                        >
                            <el-option
                                v-for="item in orgList"
                                :key="item.id"
                                :label="item.communityName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div class="footer" v-if="openData.title != '查看'">
                <el-button type="primary" @click="saveForm">确 定</el-button>
                <el-button @click="dialogClose">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["openData"],
    data() {
        return {
            formData: {
                id: "",
                orgType: "",
                planType: [],
                years: "",
                cycle: "",
                frequency: "",
                communityId: "",
            },
            orgList: [],
            formDataRules: {
                orgType: [
                    {
                        required: true,
                        message: "请选择组织类型",
                        trigger: "blur",
                    },
                ],
                years: [
                    {
                        required: true,
                        message: "请选择年份",
                        trigger: "blur",
                    },
                ],
                frequency: [
                    {
                        required: true,
                        message: "请输入频次",
                        trigger: "blur",
                    },
                ],
                cycle: [
                    {
                        required: true,
                        message: "请选择周期",
                        trigger: "blur",
                    },
                ],
                communityId: [
                    {
                        required: true,
                        message: "请选择组织",
                        trigger: "blur",
                    },
                ],
                planType: [
                    {
                        type: "array",
                        required: true,
                        message: "请选择计划类型",
                        trigger: "change",
                    },
                ],
            },
            yearList: ["2019", "2020", "2021"],
            cycleList: [
                { label: "年度", value: "1" },
                { label: "季度", value: "2" },
                { label: "月度", value: "3" },
            ],
        };
    },
    created() {
        this.formData = {
            id: "",
            orgType: "",
            planType: [],
            years: "",
            cycle: "",
            frequency: "",
            communityId: "",
        };
        this.getSelectData();
    },
    methods: {
        // 获取组织数据
        getSelectData() {
            let params = {
                pageNo: 0,
                pageSize: -1,
            };
            this.$http
                .request({
                    url: "/ypt/admin/community/info/CommunityTree",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.orgList = [];
                            return;
                        }
                        this.orgList = res.content;
                        this.formData.communityId = this.openData.socialOrgId;
                        if (this.openData.title != "新增") {
                            this.getInfos();
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        // 详情页
        getInfos() {
            let params = {
                id: this.openData.id,
            };
            this.$http
                .request({
                    url: "/ypt/admin/activityPlan/info/get",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.formData = {
                            id: res.content.id,
                            orgType: res.content.orgType,
                            planType: res.content.planType.split(","),
                            years: res.content.years,
                            cycle: res.content.cycle,
                            frequency: res.content.frequency,
                            communityId: res.content.communityId,
                        };
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        // 确定
        saveForm() {
            let url = "";
            if (this.openData.title == "新增") {
                url = "/ypt/admin/activityPlan/info/insert";
            } else {
                url = "/ypt/admin/activityPlan/info/update";
            }
            this.$refs["forms"].validate((valid) => {
                if (valid) {
                    let data = { ...this.formData };
                    data.planType = data.planType.toString();
                    data.communityId=this.openData.socialOrgId
                    this.$http
                        .request({
                            url,
                            method: "POST",
                            data,
                        })
                        .then((res) => {
                            if (res.code === 200) {
                                this.$message.success(res.message);
                                this.$emit("cancleOpen", true);
                            } else {
                                this.$message.error(res.message);
                            }
                        });
                }
            });
        },
        // 取消
        dialogClose() {
            this.$emit("cancleOpen", false);
        },
    },
};
</script>
<style lang="less" scoped>
.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
}
</style>